<template>
  <div class="mainContainer">
    <div class="filterContainer">
      <el-form class="filterForm" :inline="true" :model="filterParam">
        <el-form-item label="学校" prop="schoolName">
          <el-select
              style="width: 120px"
              v-model="filterParam.schoolName"
              placeholder="请选择学校"
              filterable
              clearable
              @change="changeSchool()"
          >
            <el-option
                v-for="cgn in schoollist"
                :key="cgn"
                :label="cgn"
                :value="cgn">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级" prop="gradename">
          <el-select
              style="width: 120px"
              v-model="filterParam.gradename"
              placeholder="请选择年级"
              filterable
              clearable
              @change="changeGrade()"
          >
            <el-option
                v-for="cgn in gradeNameList"
                :key="cgn"
                :label="cgn"
                :value="cgn">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级" prop="classname">
          <el-select
              style="width: 120px"
              v-model="filterParam.classname"
              placeholder="请选择年级"
              filterable
              clearable
              @change="initEmps()"
          >
            <el-option
                v-for="cgn in gradeClassNameList"
                :key="cgn"
                :label="cgn"
                :value="cgn">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="schoolName">
          <el-input
              placeholder="请输入姓名或流水号进行搜索..."
              suffix-icon="el-icon-search"
              clearable
              @clear="initEmps()"
              style="width: 280px; margin-right: 8px"
              v-model="filterParam.keyword"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
              style="margin-right: 8px"
              size="medium"
              icon="el-icon-search"
              type="primary"
              @click="initEmps()"
              @close="initEmps()"
          >
            搜索
          </el-button>
<!--                              <el-button-->
<!--                                  type="primary"-->
<!--                                  size="medium"-->
<!--                                  @click="toVisualRegister()"-->
<!--                                  style="margin-right: 8px"-->
<!--                              >-->
<!--                                手工录入-->
<!--                              </el-button>-->
          <el-upload
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onSuccess"
              :on-error="onError"
              :disabled="importDataDisabled"
              style="display: inline-flex; margin-right: 8px"
              action="/vhr/export/uploadBorrowerInfos"
          >
            <el-button
                :disabled="importDataDisabled"
                type="success"
                size="medium"
                :icon="importDataBtnIcon"
            >
              {{ importDataBtnText }}
            </el-button>
          </el-upload>
          <el-upload
              :show-file-list="false"
              :before-upload="beforeUpload2"
              :on-success="onSuccess2"
              :on-error="onError"
              :disabled="importAssetDataDisabled"
              style="display: inline-flex; margin-right: 8px"
              action="/vhr/export/uploadJzInfos"
          >
            <el-button
                :disabled="importAssetDataDisabled"
                type="success"
                size="medium"
                :icon="importDataBtnIcon"
            >
              {{ importAssetDataBtnText }}
            </el-button>
          </el-upload>

          <el-button
              type="primary"
              size="medium"
              icon="el-icon-download"
              @click="showAddEmpView"
          >
            下载报告
          </el-button>
          <el-button
              type="primary"
              size="medium"
              @click="exportExcel()"
              style="margin-right: 8px"
          >
            导出数据
          </el-button>
          <el-button
              @click="deleteAllEmp()"
              icon="el-icon-delete"
              type="danger"
              size="medium"
          >清除所有数据
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="tableContainer">
      <el-table
          :data="emps"
          stripe
          border
          v-loading="loading"
          element-loading-text="正在加载..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          style="width: 100%"
          :header-cell-style="tableHeaderColor "
      >
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="countyname"
            width="150"
            label="地区"
        ></el-table-column>
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="graduateschool"
            width="150"
            label="学校"
        ></el-table-column>
        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="gradename"
            width="150"
            label="年级"
        ></el-table-column>

        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="classcode"
            width="150"
            label="班级编号"
        ></el-table-column>

        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="classname"
            width="150"
            label="班级名称"
        ></el-table-column>

        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="schoolenrnum"
            width="150"
            label="学籍号"
        ></el-table-column>

        <el-table-column
            show-overflow-tooltip
            align="center"
            prop="nationname"
            width="150"
            label="民族"
        ></el-table-column>

        <el-table-column
            align="center"
            show-overflow-tooltip
            prop="name"
            fixed
            label="姓名"
            width="90"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="gendername"
            label="性别"
            width="70"
        ></el-table-column>
        <el-table-column
            align="center"
            prop="nakedrighteye"
            width="180"
            label="裸眼视力-右眼"
        ></el-table-column>
        <el-table-column
            align="center"
            prop="nakedlefteye"
            width="180"
            label="裸眼视力-左眼"
        ></el-table-column>
        <el-table-column
            align="center"
            prop="rightobs"
            width="180"
            label="右眼屈光球镜S"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="rightopc"
            width="180"
            label="右眼屈光柱镜C"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="rightoaa"
            width="180"
            label="右眼屈光轴位A"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="leftobs"
            width="180"
            label="左眼屈光球镜S"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="leftopc"
            width="180"
            label="左眼屈光柱镜C"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="leftoaa"
            width="180"
            label="左眼屈光轴位A"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="ceratoscope"
            width="150"
            label="是否为角膜塑形镜（OK镜）佩戴者"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="rightel"
            width="150"
            label="右眼近/远视情况"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="rastigmia"
            width="150"
            label="右散光情况"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="leftel"
            width="150"
            label="左眼近/远视情况"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="lastigmia"
            width="150"
            label="左眼散光情况"
        ></el-table-column>

        <el-table-column
            align="center"
            prop="cva"
            width="150"
            label="矫正情况"
        >
          <template slot-scope="scope">
            {{calcCvaTxt(scope.row.cva)}}
          </template>
        </el-table-column>

        <el-table-column
            align="center"
            prop="cva"
            width="150"
            label="戴镜情况"
        >
          <template slot-scope="scope">
              {{calcGlassCaseTxt(scope.row.glasscase)}}
          </template>
        </el-table-column>

        <el-table-column
            align="center"
            prop="createTime"
            width="180"
            label="创建时间"
        >
        </el-table-column>


        <el-table-column align="center" fixed="right" width="150" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="showEditEmpView(scope.row.id)"
              size="mini"
              >编辑</el-button
            >
            <el-button
                @click="deleteEmp(scope.row)"
                size="mini"
                type="danger"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex; justify-content: flex-end; padding-top: 8px;padding-bottom: 8px">
        <el-pagination
            background
            @current-change="currentChange"
            @size-change="sizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="60%">
      <div>
        <el-form :model="emp" :rules="rules" ref="empForm" label-width="120px">
          <el-form-item label="计划名称" prop="planname">
            <el-input
                v-model="emp.planname"
                placeholder="请输入计划名称..."
            ></el-input>
          </el-form-item>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="计划开始日期:" prop="beginContract">
                <el-date-picker
                    v-model="emp.beginContract"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="计划开始日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计划截止日期:" prop="endContract">
                <el-date-picker
                    v-model="emp.endContract"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="计划截止日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="筛查地区名称" prop="frigionname">
            <el-input
                prefix-icon="el-icon-edit"
                v-model="frigionname"
                placeholder="请输入筛查地区名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="筛查范围:" prop="filterrange">
            <el-radio-group v-model="filterrange">
              <el-radio label="全区">全区</el-radio>
              <el-radio label="学校">学校</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="学校" prop="filterschool">
            <el-select
                style="width: 120px"
                v-model="filterschool"
                placeholder="请选择学校"
                filterable
                clearable
            >
              <el-option
                  v-for="cgn in schoollist"
                  :key="cgn"
                  :label="cgn"
                  :value="cgn">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button icon="el-icon-download" type="primary" @click="downLoadFile"
        >
          导出
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
        :title="assetdialogtitle"
        :visible.sync="creditDialogVisible"
        width="80%"
    >
      <div id="chardiv">
        <div id="testChart" ref="testChart"></div>
        <div id="testChart2" ref="testChart2">999</div>
      </div>
      <h3>
        资产合计：{{ borrowerAsset.totalAsset }} ，风险评估等级：{{
          borrowerAsset.riskLevel
        }}
      </h3>
    </el-dialog>
  </div>
</template>

<script>
import FileSaver from "file-saver";

export default {
  name: "EmpBasic",
  data() {
    return {
      searchValue: {
        politicId: null,
        nationId: null,
        jobLevelId: null,
        posId: null,
        engageForm: null,
        departmentId: null,
        beginDateScope: null,
      },
      title: "",
      assetdialogtitle: "征信信息分析",
      importDataBtnText: "文件导入",
      importAssetDataBtnText: "矫正信息录入",
      importAssetProvDataBtnText: "上传资产证明",
      importDataBtnIcon: "el-icon-upload2",
      filePath: "D:\file\test.pdf", // 文件路径
      fileName: "test.pdf", // 文件名称
      importDataDisabled: false,
      importAssetDataDisabled: false,
      importAssertProvDataDisabled: false,
      allDeps: [],
      emps: [],
      loading: false,
      popVisible: false,
      popVisible2: false,
      dialogVisible: false,
      creditDialogVisible: false,
      total: 0,
      page: 1,
      filterParam: {
        keyword: "",
        schoolName: "",
        gradename:'',
        classname: ''
      },
      gradeNameList:[],
      gradeClassNameList:[],
      size: 10,
      nations: [],
      joblevels: [],
      politicsstatus: [],
      positions: [],
      schoollist: [],
      inputDepName: "所属部门",
      filterrange: "",
      filterschool: "",
      frigionname: "",
      emp: {
        planname: "",
        name: "javaboy",
        gender: "男",
        birthday: "1989-12-31",
        idCard: "610122199001011256",
        wedlock: "已婚",
        nationId: 1,
        age: 0,
        nativePlace: "陕西",
        politicId: 13,
        email: "laowang@qq.com",
        phone: "18565558897",
        address: "深圳市南山区",
        departmentId: null,
        jobLevelId: 9,
        posId: 29,
        engageForm: "劳务合同",
        tiptopDegree: "本科",
        specialty: "信息管理与信息系统",
        school: "深圳大学",
        beginDate: "2017-12-31",
        workState: "在职",
        workId: "00000057",
        contractTerm: 2,
        conversionTime: "2018-03-31",
        notworkDate: null,
        beginContract: "",
        endContract: "",
        workAge: null,
        workorg: "",
        orgtype: "",
        annualincome: 0,
        gradecode: "",
        gradename: "",
        classcode: "",
        classname: "",
        schoolenrnum: "",
        nationcode: "",
        nationname: "",
        nakedrighteye: "",
        nakedlefteye: "",
        rightobs: 0,
        rightopc: 0,
        rightoaa: 0,
        leftobs: 0,
        leftopc: 0,
        leftoaa: 0,
        ceratoscope: 0,
        gendername: "",
        righted: 0,
        lefted: 0,
        rightel: "",
        leftel: "",
        rastigmianum: 0,
        rastigmia: "",
        lastigmianum: 0,
        lastigmia: "",
        graduateschool: "",
        cva: ""
      },
      rules: {
        planname: [{required: true, message: "请输入计划名称", trigger: "blur"}],
        beginContract: [{required: true, message: "请输入合同起始日期", trigger: "change"}],
        endContract: [{required: true, message: "请输入合同结束日期", trigger: "change"}],

      },
      url: {
        page: "/employee/basic/page",
      },
      borrowerAsset: {
        borroweridnum: null,
        income: null,
        house: null,
        store: null,
        dailyUse: null,
        loan: null,
        creditCard: null,
        totalAsset: null,
        riskLevel: null,
        maxAsset: null,
      }
    };
  },
  mounted() {
    this.initEmps();
    this.initData();
    // this.initPositions();
    this.initSchoollist();
    // this.initGradeNames();
    // this.initGradeClassNames();
  },
  methods: {
    changeSchool(){
      //清空年级、班级
      this.gradeNameList = []
      this.filterParam.gradename = ''
      this.gradeClassNameList = []
      this.filterParam.className = ''
      this.initGradeNames()
      this.initEmps()
    },
    changeGrade(){
      this.gradeClassNameList = []
      this.filterParam.classname = ''
      this.initGradeClassNames()
      this.initEmps()
    },
    initGradeClassNames(){
      this.gradeClassNameList = []
      let params = {
        schoolName:this.filterParam.schoolName,
        gradename:this.filterParam.gradename,
      }
      this.getRequest("/employee/basic/getGradeClassList",{params:params}).then((resp) => {
        if (resp && resp.status) {
          this.gradeClassNameList = resp.data;
        }
      });
    },
    initGradeNames(){
      let params = {
        schoolName:this.filterParam.schoolName
      }
      this.getRequest("/employee/basic/getSchoolGradeList",{params:params}).then((resp) => {
        if (resp && resp.status) {
          this.gradeNameList = resp.data;
        }
      });
    },
    calcCvaTxt(cva){
      let cvaText = ''
      if(0 == cva){
        cvaText = '正常'
      } else if(1 == cva){
        cvaText = '欠矫正'
      } else if(2 == cva){
        cvaText = '足矫'
      }
      return cvaText
    },
    calcGlassCaseTxt(glassCase){
      console.log("戴镜情况：",glassCase)
      let caseTxt = ''
      if(0 == glassCase){
        caseTxt = '未戴眼镜'
      } else if(1 == glassCase){
        caseTxt = '框架眼镜'
      } else if(2 == glassCase){
        caseTxt = '隐形眼镜'
      }
      return caseTxt
    },
    exportExcel() {
      let loading = this.$loading({
        lock: true,
        text: '导出视力信息中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      console.log('导出检查单...')
      let params = {
        ...this.filterParam
      }
      this.getRequest('/export/expExcel', {
            params: params,
            responseType: 'blob'
          }
      ).then((res) => {
        try {
          FileSaver.saveAs(
              new Blob([res], {
                type: `application/force-download`
              }),
              `学生视力清单.xlsx`
              // `${row.productName}.xlsx`
          )
        } catch (error) {
          console.log('error')
        }
      }).catch()
      .finally(()=>{
        loading.close();
      })
    },
    tableHeaderColor() {
      return 'background:	#DCDFE6; color:#000000;';
    },
    toVisualRegister() {
      this.$router.push({
        path: '/visualRegister'
      });
    },
    searvhViewHandleNodeClick(data) {
      this.inputDepName = data.name;
      this.searchValue.departmentId = data.id;
      this.popVisible2 = !this.popVisible2;
    },
    onError(err, file, fileList) {
      this.importDataBtnText = "导入数据";
      this.importDataBtnIcon = "el-icon-upload2";
      this.importDataDisabled = false;
    },
    onSuccess(response, file, fileList) {
      this.importDataBtnIcon = "el-icon-upload";
      this.importDataBtnText = "文件导入";
      this.importDataDisabled = false;
      this.initEmps();
    },
    onSuccess2(response, file, fileList) {
      this.importDataBtnIcon = "el-icon-upload2";
      this.importAssetDataBtnText = "矫正信息录入";
      this.importAssetDataDisabled = false;
      // this.initEmps();
    },
    onSuccess3(response, file, fileList) {
      this.importDataBtnIcon = "el-icon-upload2";
      this.importAssertProvDataDisabled = false;
      this.importAssetProvDataBtnText = "上传资产证明";
      // this.initEmps();
    },
    beforeUpload() {
      this.importDataBtnText = "正在导入";
      this.importDataBtnIcon = "el-icon-loading";
      this.importDataDisabled = true;
    },
    beforeUpload2() {
      this.importDataBtnText = "正在导入";
      this.importDataBtnIcon = "el-icon-loading";
      this.importDataDisabled = true;
    },
    exportData() {
      window.open("/employee/basic/export", "_parent");
    },
    emptyEmp() {
      this.emp = {
        name: "",
        gender: "",
        birthday: "",
        idCard: "",
        wedlock: "",
        nationId: 1,
        nativePlace: "",
        politicId: 13,
        email: "",
        phone: "",
        address: "",
        departmentId: null,
        jobLevelId: 9,
        posId: 29,
        engageForm: "",
        tiptopDegree: "",
        specialty: "",
        school: "",
        beginDate: "",
        workId: "",
        contractTerm: 2,
        conversionTime: "",
        notworkDate: null,
        beginContract: "",
        endContract: "",
        workAge: null,
        workorg: "",
        orgtype: "",
        annualincome: 0,
      };
      this.inputDepName = "";
    },
    showEditEmpView(studentId) {
      this.$router.push({
        path: '/eyesightEdit',
        query:{studentId:studentId}
      });
    },
    deleteEmp(data) {
      this.$confirm(
          "此操作将永久删除【" + data.name + "】, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      )
          .then(() => {
            this.deleteRequest("/employee/basic/" + data.id).then((resp) => {
              if (resp && resp.status) {
                this.initEmps();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    jumpExpReport() {
      this.$router.push({
        path: '/expReport'
      });
    },
    deleteAllEmp() {
      this.$confirm(
          "此操作将永久删除所有数据, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      )
          .then(() => {
            this.deleteRequest("/employee/basic/deleteAll").then((resp) => {
              if (resp && resp.status) {
                this.initEmps();
                this.initSchoollist();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },

    doAddEmp() {
      if (this.emp.id) {
        this.$refs["empForm"].validate((valid) => {
          if (valid) {
            this.putRequest("/employee/basic/edit", this.emp).then((resp) => {
              if (resp && resp.status) {
                this.dialogVisible = false;
                this.initEmps();
              }
            });
          }
        });
      } else {
        this.$refs["empForm"].validate((valid) => {
          if (valid) {
            this.postRequest("/employee/basic/add", this.emp).then((resp) => {
              if (resp && resp.status) {
                this.dialogVisible = false;
                this.initEmps();
              }
            });
          }
        });
      }
    },
    handleNodeClick(data) {
      this.inputDepName = data.name;
      this.emp.departmentId = data.id;
      this.popVisible = !this.popVisible;
    },
    showDepView() {
      this.popVisible = !this.popVisible;
    },
    showDepView2() {
      this.popVisible2 = !this.popVisible2;
    },
    initPositions() {
      this.getRequest("/employee/basic/positions").then((resp) => {
        if (resp && resp.status) {
          this.positions = resp.data;
        }
      });
    },
    getMaxWordID() {
      this.getRequest("/employee/basic/maxWorkID").then((resp) => {
        if (resp && resp.status) {
          this.emp.workId = resp.data;
        }
      });
    },
    initData() {
      // 民族
      if (!window.sessionStorage.getItem("nations")) {
        this.getRequest("/employee/basic/nations").then((resp) => {
          if (resp && resp.status) {
            this.nations = resp.data;
            window.sessionStorage.setItem("nations", JSON.stringify(resp.data));
          }
        });
      } else {
        this.nations = JSON.parse(window.sessionStorage.getItem("nations"));
      }
      if (!window.sessionStorage.getItem("joblevels")) {
        this.getRequest("/employee/basic/joblevels").then((resp) => {
          if (resp && resp.status) {
            this.joblevels = resp.data;
            window.sessionStorage.setItem(
                "joblevels",
                JSON.stringify(resp.data)
            );
          }
        });
      } else {
        this.joblevels = JSON.parse(window.sessionStorage.getItem("joblevels"));
      }

      if (!window.sessionStorage.getItem("politicsstatus")) {
        this.getRequest("/employee/basic/politicsstatus").then((resp) => {
          if (resp && resp.status) {
            this.politicsstatus = resp.data;
            window.sessionStorage.setItem(
                "politicsstatus",
                JSON.stringify(resp.data)
            );
          }
        });
      } else {
        this.politicsstatus = JSON.parse(
            window.sessionStorage.getItem("politicsstatus")
        );
      }

      if (!window.sessionStorage.getItem("deps")) {
        this.getRequest("/employee/basic/deps").then((resp) => {
          if (resp && resp.status) {
            this.allDeps = resp.data;
            window.sessionStorage.setItem("deps", JSON.stringify(resp.data));
          }
        });
      } else {
        this.allDeps = JSON.parse(window.sessionStorage.getItem("deps"));
      }
    },
    sizeChange(currentSize) {
      this.size = currentSize;
      this.initEmps();
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initEmps("advanced");
    },
    showAddEmpView() {
      this.emptyEmp();
      this.title = "导出报告";
      // this.getMaxWordID();
      this.dialogVisible = true;
    },
    initEmps(type) {
      this.loading = true
      let queryParam = {
        ...this.filterParam,
        pageNo: this.page,
        pageSize: this.size
      }
      this.getRequest(this.url.page,{params: queryParam}).then((resp) => {
        if (resp && resp.status) {
          this.emps = resp.data.list;
          this.total = resp.data.total;
        }
      }).catch(e => console.log(e.message))
      .finally(() => {
        this.loading = false;
      })
    },
    initArea() {
      this.loading = true;
      this.getRequest("/employee/basic/schools").then((resp) => {
        this.loading = false;
        console.log("--学校名称加载");
        if (resp && resp.status) {
          this.schoollist = resp.data;
          console.log("--学校名称加载完成");
        }
      });
    },
    initSchoollist() {
      this.loading = true;
      this.getRequest("/employee/basic/schools").then((resp) => {
        console.log("--学校名称加载");
        if (resp && resp.status) {
          this.schoollist = resp.data;
          console.log("--学校名称加载完成");
        }
      }).catch((e) => console.log(e.message))
      .finally(()=>{this.loading = false;});
    },

    //下载
    downLoadFile() {
      //初始化学校列表
      this.$refs["empForm"].validate((valid) => {
        if (valid) {
          this.getRequest("/export/downLoadFile", {
            params: {
              filterschool: this.filterschool,
              frigionname: this.frigionname,
              filterrange: this.filterrange,
              planname: this.emp.planname,
              startdata: this.emp.beginContract,
              enddata: this.emp.endContract,
            },
            responseType: "arraybuffer",
            // ,responseType:'blob'
          }).then((res) => {
            console.log(
                this.emp.filterschool,
                this.emp.filterrange,
                this.emp.planname
            );
            let filename = ''
            if ("全区" == this.frigionname) {
              filename = this.frigionname + '-' + this.emp.planname;
            }
            FileSaver.saveAs(
                new Blob([res], {
                  type: `application/*`,
                }),
                `student_eyesight_analysis_report.pdf`
            );
          }).catch(e => console.log(e.message))
              .finally(() => {
                this.dialogVisible = false
              })
          ;
        }
      })
    },
  },
};
</script>

<style scoped>

.mainContainer {
  height: 100vh;
  background: rgba(246, 245, 245, 0.62);
  padding: 4px 1px;
}

.filterContainer {
  padding: 8px;
  height: 36px !important;
  width: 98%;
  text-align: right;
  border: 1px solid #dedddd;
  border-radius: 4px;
  margin-bottom: 4px;
}

.tableContainer {
  height: calc(100% - 10px);
  border: 1px solid #dedddd;
  border-radius: 4px;
}

#chardiv {
  display: flex;
}

#testChart {
  width: 50%;
  height: 500px;
}

#testChart2 {
  width: 50%;
  height: 500px;
}
</style>
